import initMenu from "./utils/menu";
import { buttonGoUp } from "./utils/window-scroll";
import getCookie from "./components/cookie-manager";
let isTablet = window.innerWidth < 900, isMobile = window.innerWidth < 576;
window.getCookie = getCookie;
window.addEventListener("resize", () => {
    isTablet = window.innerWidth < 900;
    isMobile = window.innerWidth < 576;
});
document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    buttonGoUp();
});
export { isMobile, isTablet };
